var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "offcanvas-body" }, [
      _c("div", { staticClass: "offcanvas-body-inner" }, [
        _c(
          "div",
          { staticClass: "input-group pt-3" },
          [
            _c("autocomplete", {
              attrs: {
                search: _vm.search,
                placeholder: "Введите фразу",
                "aria-label": "Введите фразу",
                "get-result-value": _vm.getResultValue,
              },
              on: { submit: _vm.handleSubmit },
              scopedSlots: _vm._u([
                {
                  key: "result",
                  fn: function (ref) {
                    var result = ref.result
                    var props = ref.props
                    return [
                      _c(
                        "li",
                        _vm._b(
                          { staticClass: "autocomplete-result search-result" },
                          "li",
                          props,
                          false
                        ),
                        [
                          _c("div", { staticClass: "search-result-title" }, [
                            _vm._v(
                              "\n\t\t\t\t\t\t\t\t" + _vm._s(result.name) + " "
                            ),
                            _c("span", { class: result.badgeCssClass }, [
                              _vm._v(_vm._s(result.type)),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", {
                            staticClass: "search-result-snippet",
                            domProps: { innerHTML: _vm._s(result.snippet) },
                          }),
                        ]
                      ),
                    ]
                  },
                },
              ]),
            }),
          ],
          1
        ),
        _c("small", { staticClass: "form-text pt-1" }, [
          _vm._v("Начните набирать текст, появятся подсказки."),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "offcanvas-header d-flex justify-content-between align-items-center",
      },
      [
        _c("h3", { staticClass: "offcanvas-title" }, [
          _vm._v("Поиск по сайту"),
        ]),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "close",
            attrs: {
              type: "button",
              "data-dismiss": "offcanvas",
              "aria-label": "Close",
            },
          },
          [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
        ),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }